import React, { useEffect, useMemo, useState } from 'react';
import Swal from 'sweetalert2';
import { Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import axios from '../../utils/axiosConfig';
import checkPerm from '../../utils/checkPerm';

const COMMANDS_ENDPOINT =
  process.env.REACT_APP_COMMANDS_ENDPOINT || '/operaciones2/enviarcomando';

const getEndpointUrl = () => {
  const server = process.env.REACT_APP_SERVER || '';
  if (COMMANDS_ENDPOINT.startsWith('http://') || COMMANDS_ENDPOINT.startsWith('https://')) {
    return COMMANDS_ENDPOINT;
  }

  return `${server}${COMMANDS_ENDPOINT}`;
};

const AgregarComandosModal = ({ isOpen, onClose, contratoInfo }) => {
  const initialValues = useMemo(() => ({
    device: contratoInfo?.FKLokDeviceID || '',
    comando: contratoInfo?.comando || contratoInfo?.Comando || '',
    status: 'a',
    ult_server:
      contratoInfo?.UltServer ||
      contratoInfo?.ult_server ||
      contratoInfo?.servername ||
      localStorage.getItem('server') ||
      '',
  }), [contratoInfo]);

  const [formValues, setFormValues] = useState(initialValues);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setFormValues(initialValues);
      setIsSaving(false);
    }
  }, [initialValues, isOpen]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formValues.device?.trim()) {
      Swal.fire({
        icon: 'error',
        title: 'Falta el dispositivo',
        text: 'No se encontró el device del contrato para enviar el comando.',
      });
      return;
    }

    if (!formValues.comando?.trim()) {
      Swal.fire({
        icon: 'error',
        title: 'Falta el comando',
        text: 'Debes ingresar el comando antes de continuar.',
      });
      return;
    }

    setIsSaving(true);

    try {
      const { allowed } = await checkPerm('59');

      if (!allowed) {
        return;
      }

      const payload = {
        device: formValues.device,
        comando: formValues.comando,
        status: 'a',
        ult_server: formValues.ult_server,
      };

      console.log('Sending command payload:', payload);

      const res = await axios.post(getEndpointUrl(), JSON.stringify(payload), {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('tkn')}`,
        },
        withCredentials: true,
      });

      if (!res?.data?.success) {
        throw new Error(res?.data?.message || 'No fue posible agregar el comando.');
      }

      onClose();
      Swal.fire({
        icon: 'success',
        title: 'Comando agregado',
        text: 'El comando fue enviado correctamente.',
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error al agregar comando',
        text: error?.message || 'No fue posible enviar el comando.',
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} backdrop="static" keyboard={false} centered zIndex={10050} size="sm">
      <ModalHeader toggle={onClose}>Agregar comandos</ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <input type="hidden" name="status" value={formValues.status} />
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '96px minmax(0, 1fr)',
              columnGap: 10,
              rowGap: 12,
              alignItems: 'start',
              width: '100%',
            }}
          >
            <label className="Label" style={{ margin: 0 }}>
              Device
            </label>
            <div
              style={{
                width: '100%',
                maxWidth: '100%',
                minHeight: 38,
                margin: 0,
                padding: '8px 10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 10,
                boxSizing: 'border-box',
                overflow: 'hidden',
                border: '1px solid #cdd8e3',
                borderRadius: 10,
                background: '#eef5fb',
                color: '#284b63',
                fontSize: 14,
                fontWeight: 600,
                lineHeight: 1.2,
                textAlign: 'left',
              }}
            >
              <span
                style={{
                  minWidth: 0,
                  flex: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {formValues.device || '-'}
              </span>
            </div>

            <label className="Label" htmlFor="command-comando" style={{ margin: 0 }}>
              Comando
            </label>
            <textarea
              id="command-comando"
              name="comando"
              className="TextArea"
              value={formValues.comando}
              onChange={handleChange}
              style={{
                width: '100%',
                maxWidth: '100%',
                minHeight: 72,
                margin: 0,
                resize: 'vertical',
                boxSizing: 'border-box',
                display: 'block',
                textTransform: 'uppercase',
              }}
            />

            <label className="Label" style={{ margin: 0 }}>
              Ult. server
            </label>
            <div
              style={{
                width: '100%',
                maxWidth: '100%',
                minHeight: 38,
                margin: 0,
                padding: '8px 10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 10,
                boxSizing: 'border-box',
                overflow: 'hidden',
                border: '1px solid #cdd8e3',
                borderRadius: 10,
                background: '#eef5fb',
                color: '#284b63',
                fontSize: 14,
                fontWeight: 600,
                lineHeight: 1.2,
                textAlign: 'left',
              }}
            >
              <span
                style={{
                  minWidth: 0,
                  flex: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {formValues.ult_server || '-'}
              </span>
            </div>
          </div>
          <div
            className="ButtonWrapperEdit"
            style={{
              marginTop: 20,
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <div
              className="buttons"
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                gap: 14,
                flexWrap: 'wrap',
              }}
            >
              <button type="button" className="Button" onClick={onClose} disabled={isSaving}>
                Cancelar
              </button>
              <button type="submit" className="Button blue" disabled={isSaving}>
                {isSaving ? (
                  <span className="d-inline-flex align-items-center gap-2">
                    <Spinner style={{ width: '1rem', height: '1rem' }} />
                    Guardando...
                  </span>
                ) : (
                  'Guardar comando'
                )}
              </button>
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default AgregarComandosModal;
